import Box from "@material-ui/core/Box";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";
import React from "react";
import { Color } from "../../theme";
import { HasTestId, PlainFunctionComponent } from "../../types";

export interface NavigationDrawerOverlineProps extends HasTestId {
    label: string;
    visible: boolean;
}

export const NavigationDrawerOverline: PlainFunctionComponent<NavigationDrawerOverlineProps> = ({ label, testId, visible }) => {
    const classes = useStyles();
    return (
        <Typography key="overline" className={clsx(classes.overline, { [classes.invisible]: !visible })} component={Box} data-testid={testId} variant="overline">
            {label}
        </Typography>
    );
};

const useStyles = makeStyles(
    createStyles({
        overline: {
            color: Color.grey5,
            margin: "0px 24px 16px 24px",
            whiteSpace: "normal",
        },
        invisible: {
            display: "none",
        },
    }),
);
